import SalesSummaryMonthly from "../components/salessummarymonthly";

const SalesSummaryMonthlyPage = () => {
    return (<>
        <SalesSummaryMonthly />
    </>)
}

export default SalesSummaryMonthlyPage;